import React, { useState } from "react";

/**
 * NOTE:
 * Make sure Font Awesome CSS is loaded once in your index.html:
 * <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"/>
 */

export default function FloatingSideNav() {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* TOGGLE ARROW (MOBILE ONLY) */}
      <div
        className={`mobile-toggle ${open ? "rotate" : ""}`}
        onClick={handleToggle}
        aria-label="Toggle menu"
      >
        <i className="fa-solid fa-chevron-right"></i>
      </div>

      {/* FLOATING ICON MENU */}
      <div
        className={`floating-icons-left ${open ? "show" : ""}`}
        id="floatingNav"
      >
        <button
          type="button"
          className="side-icon"
          onClick={() => scrollToSection("about")}
        >
          <i className="fa-solid fa-user"></i>
          <span>About Us</span>
        </button>

        <button
          type="button"
          className="side-icon"
          onClick={() => scrollToSection("features")}
        >
          <i className="fa-solid fa-layer-group"></i>
          <span>Features</span>
        </button>

        <button
          type="button"
          className="side-icon"
          onClick={() => scrollToSection("compare")}
        >
          <i className="fa-solid fa-diagram-project"></i>
          <span>Compare</span>
        </button>

        <button
          type="button"
          className="side-icon"
          onClick={() => scrollToSection("contact")}
        >
          <i className="fa-solid fa-envelope"></i>
          <span>Contact</span>
        </button>
      </div>

      {/* ================= STYLES ================= */}
      <style>{`
        /* =============================
           DESKTOP ORIGINAL
        ============================= */
        .floating-icons-left {
          position: fixed;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          flex-direction: column;
          gap: 14px;
          z-index: 999999;
        }

        /* =============================
           ICON
        ============================= */
        .side-icon {
          position: relative;
          width: 48px;
          height: 48px;
          background: rgba(255, 90, 125, 0.15);
          backdrop-filter: blur(10px);
          border-radius: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ff4b74;
          text-decoration: none;
          font-size: 18px;
          transition: 0.35s ease;
        }

        .side-icon i {
          width: 48px;
          text-align: center;
        }

        .side-icon span {
          display: none;
        }

        /* =============================
           DESKTOP HOVER
        ============================= */
        @media (hover:hover) {
          .side-icon:hover {
            width: 160px;
            justify-content: flex-start;
            background: linear-gradient(135deg, #ff3b73, #ff7a18);
            color: white;
            padding-left: 6px;
            box-shadow: 0 0 22px rgba(255, 80, 120, 0.8);
          }

          .side-icon:hover span {
            display: inline;
            font-size: 13px;
            font-weight: 600;
          }
        }

        /* =============================
           MOBILE MODE
        ============================= */
        .mobile-toggle {
          display: none;
        }

        @media (max-width: 768px) {
          .mobile-toggle {
            position: fixed;
            left: 5px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 22px;
            color: #ff4b74;
            z-index: 1000000;
            cursor: pointer;
            display: block;
          }

          .floating-icons-left {
            left: 0;
            transform: translate(-120%, -50%);
            transition: transform 0.4s ease;
          }

          .floating-icons-left.show {
            transform: translate(0, -50%);
          }

          .mobile-toggle.rotate {
            transform: translateY(-50%) rotate(180deg);
          }

          .side-icon {
            width: 42px;
            height: 42px;
          }
        }

        /* =============================
           NO DESKTOP ARROW
        ============================= */
        @media (min-width: 769px) {
          .mobile-toggle {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
}
